import { ContainerManagerDemo } from './ContainerManagerDemo'
import '../styles/base.css'
import './css/styles.css'

ContainerManagerDemo.init().catch(console.error)
